import React from "react";
import { images } from "../../../assets/images";
import { Card, CardContent } from "../../../components/ui/common/card";

interface ProductInfoCardProps {
  productImage?: string;
  productName?: string;
  calculatedDate: string;
  isAverageProduct: boolean;
}

/**
 * ProductInfoCard Component
 * Single Responsibility: Display product image and calculation date
 */
export const ProductInfoCard: React.FC<ProductInfoCardProps> = ({
  productImage,
  productName,
  calculatedDate,
  isAverageProduct
}) => {
  return (
    <Card className="tw-border-border">
      <CardContent className="tw-p-1 tw-flex tw-flex-col tw-items-center tw-text-center tw-h-full tw-justify-center">
        {!isAverageProduct && (
          <>
            <p className="tw-text-xs tw-text-muted-foreground tw-mb-1">Calculated on</p>
            <p className="tw-text-xs tw-text-foreground tw-bg-muted tw-px-3.5 tw-py-1.5 tw-rounded-md tw-mb-4">
              {calculatedDate}
            </p>
          </>
        )}
        <img
          src={productImage || images.notFound}
          alt={productName || "Product"}
          width={100}
          height={100}
          className="tw-object-contain tw-mb-1.5"
        />
        <p className="tw-text-sm tw-font-medium tw-text-foreground">{productName}</p>
      </CardContent>
    </Card>
  );
};
